var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0026 17.3337C6.54427 17.3337 6.15191 17.1705 5.82552 16.8441C5.49913 16.5177 5.33594 16.1253 5.33594 15.667H8.66927C8.66927 16.1253 8.50608 16.5177 8.17969 16.8441C7.8533 17.1705 7.46094 17.3337 7.0026 17.3337ZM0.335938 14.8337V13.167H2.0026V7.33366C2.0026 6.18088 2.34983 5.15658 3.04427 4.26074C3.73872 3.36491 4.64149 2.7781 5.7526 2.50033V1.91699C5.7526 1.56977 5.87413 1.27463 6.11719 1.03158C6.36024 0.78852 6.65538 0.666992 7.0026 0.666992C7.34983 0.666992 7.64497 0.78852 7.88802 1.03158C8.13108 1.27463 8.2526 1.56977 8.2526 1.91699V2.18783C8.11372 2.4656 8.00955 2.75727 7.9401 3.06283C7.87066 3.36838 7.83594 3.68088 7.83594 4.00033C7.83594 5.1531 8.24219 6.13574 9.05469 6.94824C9.86719 7.76074 10.8498 8.16699 12.0026 8.16699V13.167H13.6693V14.8337H0.335938ZM12.0026 6.50033C11.3082 6.50033 10.7179 6.25727 10.2318 5.77116C9.74566 5.28505 9.5026 4.69477 9.5026 4.00033C9.5026 3.30588 9.74566 2.7156 10.2318 2.22949C10.7179 1.74338 11.3082 1.50033 12.0026 1.50033C12.697 1.50033 13.2873 1.74338 13.7734 2.22949C14.2595 2.7156 14.5026 3.30588 14.5026 4.00033C14.5026 4.69477 14.2595 5.28505 13.7734 5.77116C13.2873 6.25727 12.697 6.50033 12.0026 6.50033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.9f8b608317f4166785a72f1d61f5570c.svg";
export { ForwardRef as ReactComponent };